/**
 * NOTE: This service refers to the <Flag> Atlaskit component and managing how content types trigger
 * it. It does NOT refer to feature flags
 * See: https://atlassian.design/components/flag/examples
 */
import type { FlagsStateContainer } from '@confluence/flags';

import { getContentTypesFlagIcon } from '../utils/get-content-types-flag-icon';

import type { ContentTypesFlagProps } from './content-types-flag-service-types';

export class ContentTypesFlagService {
	#flags: FlagsStateContainer;

	constructor(flags: FlagsStateContainer) {
		this.#flags = flags;
	}

	showFlag(flagProps: ContentTypesFlagProps) {
		this.#flags.showFlag({
			...flagProps,
			customIcon:
				flagProps.type === 'custom'
					? getContentTypesFlagIcon(flagProps.iconString, flagProps.iconColor)
					: undefined,
		});
	}

	hideFlag(flagId: string) {
		this.#flags.hideFlag(flagId);
	}
}
